import { render, staticRenderFns } from "./AccesosMetricas.vue?vue&type=template&id=64a3d24c&scoped=true"
import script from "./AccesosMetricas.vue?vue&type=script&lang=js"
export * from "./AccesosMetricas.vue?vue&type=script&lang=js"
import style0 from "./AccesosMetricas.vue?vue&type=style&index=0&id=64a3d24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3d24c",
  null
  
)

export default component.exports